import React from "react";
import { Plus, Check } from "lucide-react";

export default function ProductCard({ image, title, desc, stats, onAddToCart, isAdded }) {
  return (
    <div className="bg-white rounded-[2.5rem] overflow-hidden border border-gray-100 shadow-sm group hover:shadow-2xl transition-all duration-700 flex flex-col h-full">
      
      <div className="h-60 overflow-hidden relative bg-gray-50">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-contain p-4 group-hover:scale-110 transition-transform duration-1000" 
        />
      </div>

      <div className="p-8 flex flex-col flex-grow">
        <h3 className="text-xl font-black text-[#4B3621] tracking-tighter mb-3 uppercase">
          {title}
        </h3>
        <p className="text-gray-500 text-xs leading-relaxed mb-6 flex-grow font-medium">
          {desc}
        </p>
        
        <div className="grid grid-cols-3 gap-2 border-t border-gray-50 pt-6 mb-6">
          {Object.entries(stats).map(([key, value]) => (
            <div key={key}>
              <p className="text-[7px] font-black uppercase text-[#D4AF37] tracking-[0.1em] mb-1">{key}</p>
              <p className="text-[10px] font-extrabold text-[#4B3621] uppercase truncate">{value}</p>
            </div>
          ))}
        </div>

        <button 
          onClick={onAddToCart}
          disabled={isAdded}
          className={`w-full py-3.5 rounded-xl font-black text-[9px] uppercase tracking-widest flex items-center justify-center gap-2 transition-all ${
            isAdded 
            ? "bg-gray-100 text-gray-400 cursor-default" 
            : "bg-[#4B3621] text-white hover:bg-[#2D5A27] shadow-lg active:scale-95"
          }`}
        >
          {isAdded ? (
            <><Check size={12} /> In Selection</>
          ) : (
            <><Plus size={12} /> Add to Selection</>
          )}
        </button>
      </div>
    </div>
  );
}